import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling-light";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "HeadersRefreshToken"*/ "./lazyIndex"), { name: "HeadersRefreshToken" });

export const lazyGetAndUpdateAccessToken: LazyAction<typeof lazyIndex.getAndUpdateAccessToken, typeof lazyModule> = new LazyAction(lazyModule, m => m.getAndUpdateAccessToken);

export { triggerReInitializeAccount } from "./publicActions";
